export class ResetPasswordRegisterResult {
  isOk: boolean;
  isExpired: boolean;
}
